//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { ReactNode } from 'react';
import Fieldset from './Fieldset';
import styled from '@emotion/styled';
import { Palette } from '@mui/material';

type MetaGroupProps = {
  children: ReactNode;
  label: string;
  color?: keyof Palette;
};

const MetaGroup = ({ children, label, color = 'default' }: MetaGroupProps) => {
  return (
    <Wrapper>
      <Fieldset label={label} color={color}>
        {children}
      </Fieldset>
    </Wrapper>
  );
};

export default MetaGroup;

const Wrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;
